import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { StoresFinderContainer } from "./StoresFinderContainer.js";
import { PickupLocationInformation } from "../../../../../components/StepShipping/modules/ShippingMethods/components/PickupLocationInformation.js";
import { PickupWarningMessage } from "../../../../../components/StepShipping/modules/ShippingMethods/components/PickupWarningMessage.js";
const PickupStoresContainer = ({
  isTitleHidden = false,
  hasWarningMessageOnly = false,
  selectedStore,
  onStoreSelect,
  onShippingModalClose,
  hasEditButton = true
}) => {
  const { getLabel } = useIntl();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (!selectedStore) {
      setModalIsOpen(true);
    }
  }, [selectedStore]);
  const onPickupModalClose = () => {
    setModalIsOpen(false);
    onShippingModalClose?.();
  };
  const onPickupModalShow = (event) => {
    setModalIsOpen(true);
    event && event.preventDefault();
  };
  const labels = React.useMemo(
    () => ({
      storeFinderAction: getLabel("checkout.storeFinder.action"),
      noSelection: getLabel("checkout.store.selectStore.message"),
      noSelectionLink: getLabel("checkout.store.selectStore.link"),
      title: getLabel("checkout.store.title")
    }),
    [getLabel]
  );
  const handleStoreSelect = React.useCallback(
    (store) => {
      if (!store) {
        return;
      }
      setModalIsOpen(false);
      onStoreSelect(store);
    },
    [onStoreSelect]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, modalIsOpen && /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "checkout-step--shipping__modal",
      showIcon: true,
      iconClassName: "checkout-step--shipping__modal__close",
      isOpen: modalIsOpen,
      onModalClose: onPickupModalClose
    },
    /* @__PURE__ */ React.createElement(
      StoresFinderContainer,
      {
        onPickupStoreSelect: handleStoreSelect,
        hasAttributesAsTags: true
      }
    )
  ), selectedStore && !hasWarningMessageOnly ? /* @__PURE__ */ React.createElement(
    PickupLocationInformation,
    {
      isTitleHidden,
      title: labels.title,
      location: selectedStore,
      onPickupModalShow: hasEditButton ? onPickupModalShow : void 0
    }
  ) : /* @__PURE__ */ React.createElement(
    PickupWarningMessage,
    {
      labels,
      onPickupModalShow: hasEditButton ? onPickupModalShow : void 0
    }
  ));
};
export {
  PickupStoresContainer
};
//# sourceMappingURL=PickupStoresContainer.js.map
